import {
  Typography,
  Row,
  Col,
  Table,
  message,
  Select,
  DatePicker,
  Button,
  Space,
  Input,
} from "antd";
import { useEffect, useState } from "react";
import { GetDataFromServer, GetDataListFromServer } from "../../lib/api";
import { AGENT_LIST, AGENT_TRANSACTION_LIST } from "../../lib/config";
import { moneyFormat, queryHandler } from "../../lib/global_functions";
import { QUERY_AGENT_TRANSACTION_ALL } from "../../lib/query_obj";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import { setState } from "../../redux/user";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import SettingExpandable from "./setting_expandable";

const { Text } = Typography;
const { Option } = Select;
export default function SettingTransactionPage() {
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  const dispatch = useDispatch();

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });

  const [filter, setFilter] = useState({
    name: "",
    code: "",
    type: "",
    start_date: "",
    end_date: "",
  });

  async function getRefreshDataList() {
    try {
      const res = await GetDataFromServer(AGENT_LIST, user.access_token);

      dispatch(
        setState({
          ...user,
          points: res.data.points,
          total_deposit_points: res.data.total_deposit_points,
          total_withdraw_points: res.data.total_withdraw_points,
        })
      );
    } catch (error) {
      toast.error(error?.response?.data?.error || "Connection Error");
    }
  }

  async function getDataList(page_number, per_page, updateFilter) {
    const currentFilter = updateFilter || filter;
    const queryFilter = {
      ...currentFilter,
      start_date: currentFilter.start_date
        ? moment
            .tz(currentFilter.start_date, "Asia/Yangon")
            .startOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        : "",
      end_date: currentFilter.end_date
        ? moment
            .tz(currentFilter.end_date, "Asia/Yangon")
            .endOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        : "",
    };
    setLoading(true);
    await GetDataListFromServer(
      AGENT_TRANSACTION_LIST,
      queryHandler(queryFilter, QUERY_AGENT_TRANSACTION_ALL, {
        page_number,
        per_page,
      }),
      user.access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        updateFilter && setFilter(updateFilter);
        setPagin((prev) => ({ ...prev, page_number, per_page, total }));
        setList(Array.isArray(res) ? res : []);
      })
      .catch((error) => {
        setLoading(false);
        message.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
    getRefreshDataList();
  }, []);

  const columns = [
    {
      title: "Direction",
      dataIndex: "direction",
      render: (direction) => (
        <Text
          style={{
            color: direction === "MASTER_TO_AGENT" ? "cyan" : "magenta",
          }}
        >
          {direction}
        </Text>
      ),
    },
    {
      title: "Transaction Type",
      dataIndex: "type",
      render: (record) => {
        return (
          <Text
            style={{
              fontSize: "15px",
              color: record === "DEPOSIT" ? "lime" : "orange",
            }}
          >
            {record}
          </Text>
        );
      },
    },
    {
      title: "Agent",
      dataIndex: "code",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (_, record) => (
        <Text>
          {moneyFormat(record.amount)}{" "}
          <span style={{ color: "green" }}>({record.currency})</span>
        </Text>
      ),
    },
    {
      title: "Points",
      dataIndex: "points",
      render: (record) => <Text>{moneyFormat(record)}</Text>,
    },
    {
      title: "Bank Type",
      dataIndex: "bank_type",
      render: (record) => {
        return renderBankOption(record);
      },
    },
    {
      title: "Date",
      dataIndex: "created_at",
      render: (record) =>
        moment.utc(record).tz("Asia/Yangon").format("DD-MM-YYYY, HH:mm:ss"),
    },
  ];

  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };
  function renderBankOption(value) {
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={iconPath}
          alt={value}
          style={{ width: 30, height: 30, marginRight: 8, borderRadius: "5px" }}
        />
      </div>
    );
  }

  function clearFilter() {
    getDataList(pagin.page_number, pagin.per_page, {
      ...filter,
      code: "",
      type: "",
      start_date: "",
      end_date: "",
    });
  }

  return (
    <>
      <Row gutter={[16, 24]} justify="end">
        <Col span={24}>
          <Row align="middle">
            <Col>
              <Text>Code : &nbsp;</Text>
            </Col>

            <Col>
              <Input
                size={user.ui_size}
                style={{ width: "150px" }}
                value={filter.code}
                placeholder="Search by Code"
                onChange={(e) => setFilter({ ...filter, code: e.target.value })}
              />
            </Col>

            <Col style={{ marginLeft: "20px" }}>
              <Text>Transaction Type : &nbsp;</Text>
            </Col>
            <Col>
              <Select
                size={user.ui_size}
                style={{ width: "150px" }}
                placeholder="Select Type"
                value={filter.type || undefined}
                onChange={(value) => setFilter({ ...filter, type: value })}
                allowClear={false}
              >
                <Option value="DEPOSIT">Deposit</Option>
                <Option value="WITHDRAW">Withdraw</Option>
              </Select>
            </Col>

            <Col style={{ marginLeft: "20px" }}>
              <Text>Date : &nbsp;</Text>
            </Col>
            <Col>
              <DatePicker.RangePicker
                size={user.ui_size}
                style={{ width: "300px" }}
                format={"YYYY-MM-DD"}
                value={[
                  filter.start_date
                    ? dayjs(filter.start_date, "YYYY-MM-DD")
                    : null,
                  filter.end_date ? dayjs(filter.end_date, "YYYY-MM-DD") : null,
                ]}
                onChange={(dates) => {
                  setFilter({
                    ...filter,
                    start_date: dates?.[0]?.format("YYYY-MM-DD") || "",
                    end_date: dates?.[1]?.format("YYYY-MM-DD") || "",
                  });
                }}
              />
            </Col>

            <Col style={{ marginLeft: "20px" }}>
              <Space>
                <Button
                  size={user.ui_size}
                  type="primary"
                  onClick={() => {
                    getDataList(1, pagin.per_page);
                  }}
                >
                  Search
                </Button>
                <Button
                  size={user.ui_size}
                  type="primary"
                  onClick={() => clearFilter()}
                >
                  Clear
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table
            size={user.ui_size}
            loading={loading}
            columns={columns}
            dataSource={list}
            rowKey={(e) => e.id}
            pagination={{
              total: pagin.total,
              current: pagin.page_number,
              pageSize: pagin.per_page,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50],
              onChange: (pageNumber, perPage) => {
                getDataList(pageNumber, perPage);
              },
              onShowSizeChange: (current, size) => {
                getDataList(1, size);
              },
            }}
            expandable={{
              expandedRowRender: (record) => (
                <SettingExpandable record={record} />
              ),
            }}
          />
        </Col>
      </Row>
    </>
  );
}
